import script from "./infoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./infoModal.vue?vue&type=script&setup=true&lang=ts"

import "./infoModal.vue?vue&type=style&index=0&id=2fb577c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb577c2"]])

export default __exports__